// extracted by mini-css-extract-plugin
export default {"SearchBar":"TagView_SearchBar__X9C7N","Content":"TagView_Content__ZDtgd"};